import { map } from 'lodash';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import type { IReport } from './Report.interface';
import ReportAggregation from './ReportAggregation';
import ReportFilter from './ReportFilter';
import ReportQuick from './ReportQuick';

export default class Report extends Root implements IReport {
  name: string;
  fields: Array<string>;
  filters: Array<ReportFilter>;
  aggregations: Array<ReportAggregation>;
  quick: ReportQuick;
  isQuick: boolean;
  isShared: boolean;

  getName() {
    return this.name;
  }

  static build = (data: IReport) => new Report(data);
  static blank = () =>
    new Report({ quick: { isLeaderBoard: true }, isQuick: true, isActive: true });

  /**
   * Constructor
   * @param {IReport} data
   */
  constructor(data?: IReport) {
    super(DocType.of('__datum.report'), data);

    this.name = data?.name || '';
    this.fields = data?.fields || [];
    this.filters = map(data?.filters, (obj) => new ReportFilter(obj));
    this.aggregations = map(data?.aggregations, (obj) => new ReportAggregation(obj));
    this.quick = new ReportQuick(data?.quick);
    this.isQuick = data?.isQuick === true;
    this.isShared = data?.isShared === true;
  }
}
